export const news = [
  {
    id: "news-001",
    title: "国产历史大片《长河落日》口碑爆棚，首周票房刷新纪录",
    date: "2026-10-14",
    category: "行业动态",
    summary:
      "上映首周，《长河落日》凭借恢弘的战争场面与细腻的人物群像收获超高口碑，票房连破多项纪录，成为近期最受关注的国产历史题材作品。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20editorial%20image%20of%20an%20epic%20battlefield%20at%20sunset%20with%20dramatic%20amber%20sky%20and%20distant%20silhouettes%2C%20painterly%20atmospheric%20historical%20mood%2C%20soft%20haze%2C%20high%20detail%2C%20no%20text&width=800&height=560&seq=news-thumb-001&orientation=landscape",
    source: "影视观察",
    author: "编辑部",
    content: [
      "由陈望川执导的历史剧情片《长河落日》自上映以来持续引发观影热潮。影片以一场决定命运的大决战为背景，讲述了几位普通士兵在时代洪流中的抉择与守望，被观众誉为“近年最具史诗气质的国产历史片”。",
      "据发行方公布的数据，影片上映首周便接连打破多项同档期票房纪录，多地影院出现黄金场次售罄的情况。不少观众表示，影片不仅战争场面震撼，人物刻画同样令人动容。",
      "影评人指出，《长河落日》的成功在于它没有停留在宏大的战争奇观，而是把镜头对准了普通个体的情感与信念，让历史有了可触摸的温度。",
      "业内人士认为，该片的热映再次印证了观众对高质量国产历史题材作品的旺盛需求，也为后续同类型创作提供了宝贵经验。",
    ],
  },
  {
    id: "news-002",
    title: "悬疑剧《迷雾档案》第二季官宣，原班人马回归",
    date: "2026-10-11",
    category: "剧集资讯",
    summary:
      "口碑刑侦悬疑剧《迷雾档案》正式宣布启动第二季，主创与主演阵容基本延续第一季，新一季将围绕一桩跨越二十年的悬案展开。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20dim%20detective%20office%20with%20a%20corkboard%20of%20photos%20and%20warm%20desk%20lamp%2C%20cold%20grey-blue%20moody%20tones%2C%20painterly%20illustration%2C%20soft%20haze%2C%20high%20detail%2C%20no%20text&width=800&height=560&seq=news-thumb-002&orientation=landscape",
    source: "剧集前线",
    author: "林络",
    content: [
      "凭借扎实的剧本与严谨的刑侦细节，《迷雾档案》成为年度口碑黑马。日前，制作方正式宣布第二季启动，导演穆远与主演阵容悉数回归。",
      "据介绍，第二季将延续“重启悬案”的主线设定，围绕一桩跨越二十年的旧案展开。编剧团队表示，新一季在案件复杂度与人物情感深度上都将全面升级。",
      "主演程昱透露，为了贴近角色，他提前跟随相关领域从业者体验生活，希望能呈现更真实的状态。",
      "该剧预计明年与观众见面，具体播出档期尚未公布。",
    ],
  },
  {
    id: "news-003",
    title: "《星海征途》视觉特辑发布，揭秘太空场景幕后制作",
    date: "2026-10-09",
    category: "幕后揭秘",
    summary:
      "科幻电影《星海征途》发布全新视觉特辑，主创团队首次公开深空场景的概念设计与特效制作过程，展现国产科幻的全新工业水准。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20glowing%20nebula%20and%20ringed%20planet%20in%20deep%20indigo%20space%20with%20warm%20amber%20star%20glow%2C%20luminous%20atmospheric%20haze%2C%20painterly%20sci-fi%20illustration%2C%20high%20detail%2C%20no%20text&width=800&height=560&seq=news-thumb-003&orientation=landscape",
    source: "影视观察",
    author: "周异",
    content: [
      "《星海征途》讲述人类首支深空远航舰队寻找新家园的故事。最新发布的视觉特辑，用近十分钟的篇幅揭开了影片深空场景的创作过程。",
      "美术指导介绍，团队参考了大量真实天文影像，仅“星云走廊”一场戏就打磨了数月。为了让太空既有科学质感又不失浪漫，团队在色彩上做了大量尝试。",
      "导演罗砚舟表示，科幻不只是视觉奇观，更重要的是借由陌生的宇宙来映照熟悉的人性。",
      "影片目前仍在后期制作阶段，发行方透露将争取在明年暑期档与观众见面。",
    ],
  },
  {
    id: "news-004",
    title: "年代大剧《京华烟云录》收官，群像叙事获好评",
    date: "2026-10-06",
    category: "剧集资讯",
    summary:
      "历时一个多月播出，《京华烟云录》正式收官。剧集以百年家族兴衰为轴，凭借扎实的剧本与丰满群像收获大批观众喜爱。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20grand%20traditional%20Chinese%20mansion%20courtyard%20at%20dusk%20with%20lanterns%20and%20blossom%20trees%2C%20muted%20jade%20and%20warm%20gold%2C%20soft%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=800&height=560&seq=news-thumb-004&orientation=landscape",
    source: "剧集前线",
    author: "苏晓",
    content: [
      "《京华烟云录》以百年家族三姐妹的命运为主线，串联起一个时代的变迁。剧集收官当晚相关话题登上多个平台热榜。",
      "不少观众表示，剧中没有脸谱化的善恶，每个角色都有自己的困境与选择，这种“群像式”的叙事让人物格外立体。",
      "业内评论认为，该剧在置景、台词与表演上都保持了较高水准，为年代题材创作提供了新的参考。",
      "制作方透露，未来或将围绕剧中人物推出衍生故事，具体计划仍在筹备中。",
    ],
  },
  {
    id: "news-005",
    title: "影迷热议：软科幻《时间的褶皱》为何看哭这么多人",
    date: "2026-10-03",
    category: "影评推荐",
    summary:
      "《时间的褶皱》以“穿越同一个黄昏”的设定讲述父女情深，上映后引发广泛讨论。观众表示，影片用科幻外壳包裹了最朴素的亲情。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Surreal%20editorial%20image%20of%20a%20fractured%20clock%20and%20light%20particles%20dissolving%20into%20warm%20glow%2C%20deep%20blue%20and%20gold%20grading%2C%20ethereal%20atmosphere%2C%20painterly%20conceptual%20illustration%2C%20high%20detail%2C%20no%20text&width=800&height=560&seq=news-thumb-005&orientation=landscape",
    source: "影评专栏",
    author: "顾一鸣",
    content: [
      "《时间的褶皱》上映后，关于它的讨论始终没有停歇。影片讲述一位物理学家为了把女儿的记忆从时间褶皱中带回现实，一次次穿越同一个黄昏的故事。",
      "不少观众在社交平台分享观影感受，称影片“用最冷静的科学设定，讲了最滚烫的亲情”，放映结束后放映厅里久久没有人离场。",
      "影评人认为，优秀的软科幻从来不是比拼设定的复杂，而是借助设定去触碰那些我们平常难以言说的情感，《时间的褶皱》做到了这一点。",
      "影片目前仍在热映中，多条相关话题持续登上热榜。",
    ],
  },
  {
    id: "news-006",
    title: "《都市守望者》聚焦职场现实，引打工人强烈共鸣",
    date: "2026-09-29",
    category: "剧集资讯",
    summary:
      "都市职场剧《都市守望者》正在热播，剧中对职场困境与成长的真实描摹引发广泛讨论，相关话题多次登上社交平台热榜。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Contemporary%20editorial%20image%20of%20a%20glass%20skyscraper%20skyline%20at%20blue%20hour%20with%20warm%20office%20lights%2C%20cool%20navy%20and%20amber%20accents%2C%20subtle%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=800&height=560&seq=news-thumb-006&orientation=landscape",
    source: "剧集前线",
    author: "林络",
    content: [
      "《都市守望者》将镜头对准三位背景各异的年轻职场人。剧集没有回避加班、内卷、理想受挫等现实议题，而是选择以更温和、也更有力量的方式去呈现。",
      "播出后，剧中不少台词被观众截图转发，“想赢，但要赢得体面”等表达引发大量共鸣。",
      "主创团队表示，希望这部剧能让每一个在都市里努力生活的人感到被看见。",
      "该剧目前更新至后半程，热度持续走高。",
    ],
  },
  {
    id: "news-007",
    title: "武侠剧《侠影行》武打设计获赞，传统美学回归",
    date: "2026-09-25",
    category: "幕后揭秘",
    summary:
      "古装武侠剧《侠影行》凭借实景拍摄与扎实的武打设计收获好评，剧中浓郁的东方美学风格成为观众热议的焦点。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20misty%20bamboo%20forest%20with%20a%20silhouetted%20swordsman%20in%20flowing%20robes%2C%20deep%20jade%20green%20and%20soft%20white%2C%20drifting%20clouds%2C%20painterly%20oriental%20illustration%2C%20high%20detail%2C%20no%20text&width=800&height=560&seq=news-thumb-007&orientation=landscape",
    source: "影视观察",
    author: "周异",
    content: [
      "《侠影行》的武打场面被不少观众称为“久违的武侠味道”。剧组坚持大量实景拍摄与真人实打，尽量减少过度特效。",
      "武术指导介绍，团队为不同门派设计了各具特色的动作语言，让每一次交手都能看出人物的性格。",
      "在视觉上，剧集大量运用竹、雾、水等东方意象，营造出含蓄而克制的古典意境。",
      "主创表示，希望用一部作品让更多年轻观众重新感受到武侠的浪漫。",
    ],
  },
  {
    id: "news-008",
    title: "《未来纪元》定档，华语科幻剧集迎来新一波热潮",
    date: "2026-09-21",
    category: "行业动态",
    summary:
      "华语科幻剧集《未来纪元》正式宣布定档，凭借硬核设定与高水准制作预告引发关注，被视为华语科幻剧的重要一步。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Futuristic%20editorial%20image%20of%20a%20neon%20mega%20city%20skyline%20reflected%20in%20rain%2C%20deep%20indigo%20and%20warm%20amber%20neon%20glow%2C%20dense%20atmospheric%20haze%2C%20painterly%20cyberpunk%20illustration%2C%20high%20detail%2C%20no%20text&width=800&height=560&seq=news-thumb-008&orientation=landscape",
    source: "行业观察",
    author: "编辑部",
    content: [
      "《未来纪元》把故事设定在人工智能深度介入生活的未来都市，通过一桩离奇失控事件，牵引出一场关乎技术与人性的博弈。",
      "从已释出的预告来看，剧集在世界观构建与视觉呈现上都投入了相当的心力，被不少观众称为“近年最具电影质感的华语科幻剧”。",
      "导演尹川表示，剧集讨论的核心问题在当下已初见端倪：当技术足够强大，我们该如何定义“人”。",
      "该剧定档消息公布后迅速登上热搜，相关讨论持续升温。",
    ],
  },
];